module.exports = __webpack_public_path__ + "img/yelp.514337fa.svg";